var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-end py-2" },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal.modal-lg",
                  modifiers: { "modal-lg": true },
                },
              ],
              attrs: { variant: "primary" },
            },
            [
              _c("b-icon", { attrs: { icon: "plus-circle" } }),
              _vm._v(" Create Job Card "),
            ],
            1
          ),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal.modal-addPO",
                  modifiers: { "modal-addPO": true },
                },
              ],
              staticClass: "mx-2",
              attrs: { variant: "primary" },
            },
            [
              _c("b-icon", { attrs: { icon: "plus-circle" } }),
              _vm._v(" Push Orders "),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Delivery Date From",
                        "label-for": "h-Order-name",
                        "label-cols-md": "4",
                      },
                    },
                    [
                      _c("flat-pickr", {
                        staticClass: "form-control",
                        attrs: {
                          config: { enableTime: true, dateFormat: "Y-m-d H:i" },
                        },
                        on: {
                          "on-close": function ($event) {
                            return _vm.orderFilterChanged()
                          },
                        },
                        model: {
                          value: _vm.deliveryDateFrom,
                          callback: function ($$v) {
                            _vm.deliveryDateFrom = $$v
                          },
                          expression: "deliveryDateFrom",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Delivery Date To",
                        "label-for": "h-Order-name",
                        "label-cols-md": "4",
                      },
                    },
                    [
                      _c("flat-pickr", {
                        staticClass: "form-control",
                        attrs: {
                          config: { enableTime: true, dateFormat: "Y-m-d H:i" },
                        },
                        on: {
                          "on-close": function ($event) {
                            return _vm.orderFilterChanged()
                          },
                        },
                        model: {
                          value: _vm.deliveryDateTo,
                          callback: function ($$v) {
                            _vm.deliveryDateTo = $$v
                          },
                          expression: "deliveryDateTo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-form-group",
            {
              attrs: {
                label: "Products",
                "label-for": "h-Order-name",
                "label-cols-md": "2",
              },
            },
            [
              _c(
                "b-form-select",
                {
                  attrs: { options: _vm.optionsProduct },
                  on: {
                    change: function ($event) {
                      return _vm.orderFilterChanged()
                    },
                  },
                  model: {
                    value: _vm.selectedProduct,
                    callback: function ($$v) {
                      _vm.selectedProduct = $$v
                    },
                    expression: "selectedProduct",
                  },
                },
                [_c("option", { attrs: { value: "" } }, [_vm._v("All")])]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-lg",
            centered: "",
            size: "xl",
            title: "Create Job Card",
            "hide-footer": "",
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "text-center",
                      attrs: { "bg-variant": "info" },
                    },
                    [
                      _c("h3", [_vm._v("Product Name")]),
                      _c("h1", { staticClass: "text-warning" }, [
                        _vm._v(_vm._s(_vm.productName)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "text-center",
                      attrs: { "bg-variant": "warning" },
                    },
                    [
                      _c("h3", [_vm._v("Available Balance")]),
                      _c("h1", { staticClass: "text-info" }, [
                        _vm._v(_vm._s(_vm.availableBalance)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "text-center",
                      attrs: { "bg-variant": "info" },
                    },
                    [
                      _c("h3", [_vm._v("Quantity Requested")]),
                      _c("h1", { staticClass: "text-warning" }, [
                        _vm._v(_vm._s(_vm.quantityRequested)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "text-center",
                      attrs: { "bg-variant": "info" },
                    },
                    [
                      _c("h3", [_vm._v("Demand Quantity")]),
                      _c("h1", { staticClass: "text-warning" }, [
                        _vm._v(_vm._s(_vm.demandQuantity)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "text-center",
                      attrs: { "bg-variant": "warning" },
                    },
                    [
                      _c("h3", [_vm._v("Production Limit")]),
                      _c("h1", { staticClass: "text-info" }, [
                        _vm._v(_vm._s(_vm.productionLimit)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "text-center",
                      attrs: { "bg-variant": "success" },
                    },
                    [
                      _c("h3", [_vm._v("Production Quantity")]),
                      _c("h1", { staticClass: "text-warning" }, [
                        _vm._v(_vm._s(_vm.quantityToBeProduced)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "text-center",
                      attrs: { "bg-variant": "secondary" },
                    },
                    [
                      _c("h3", [_vm._v("Job Cards")]),
                      _c("h1", { staticClass: "text-warning" }, [
                        _vm._v(_vm._s(_vm.numberOfJobCards)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c("h6", { staticClass: "mb-2" }, [
                    _vm._v("Choose Warehouse:"),
                  ]),
                  _c("b-form-select", {
                    attrs: { options: _vm.optionsWarehouse },
                    model: {
                      value: _vm.warehouseId,
                      callback: function ($$v) {
                        _vm.warehouseId = $$v
                      },
                      expression: "warehouseId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("CreateJob", {
                    attrs: {
                      Orders: _vm.selectedOrders,
                      ProductionLimit: _vm.productionLimit,
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticStyle: { "text-align": "right" },
                  attrs: { cols: "12" },
                },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(255, 255, 255, 0.15)",
                          expression: "'rgba(255, 255, 255, 0.15)'",
                          modifiers: { 400: true },
                        },
                      ],
                      staticClass: "mr-1",
                      attrs: { type: "submit", variant: "primary" },
                      on: { click: _vm.addJobCard },
                    },
                    [
                      _vm.jobLoading
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v(" Add Job Card(s) "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-addPO",
            centered: "",
            title: "Create Push Order",
            "hide-footer": "",
          },
        },
        [
          _c(
            "b-container",
            [
              _c(
                "validation-observer",
                { ref: "addPushForm" },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Product" } },
                                [
                                  _c("b-form-select", {
                                    attrs: { options: _vm.optionsProduct },
                                    model: {
                                      value: _vm.itemIdProduct,
                                      callback: function ($$v) {
                                        _vm.itemIdProduct = $$v
                                      },
                                      expression: "itemIdProduct",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Quantity" } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "Quantity",
                                      vid: "Quantity",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "Quantity",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                                name: "Quantity",
                                                type: "number",
                                                placeholder: "Quantity",
                                              },
                                              model: {
                                                value: _vm.Quantity,
                                                callback: function ($$v) {
                                                  _vm.Quantity = $$v
                                                },
                                                expression: "Quantity",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Comment",
                                    "label-for": "login-Comment",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: { name: "Comment", vid: "Comment" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-textarea", {
                                              attrs: {
                                                id: "login-Comment",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                                name: "login-Comment",
                                                placeholder:
                                                  "Description for Push Order | Add Customer details if for customer",
                                              },
                                              model: {
                                                value: _vm.Comment,
                                                callback: function ($$v) {
                                                  _vm.Comment = $$v
                                                },
                                                expression: "Comment",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Start Date",
                                    "label-for": "Start Date",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "Start Date",
                                      vid: "Start Date",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-datepicker", {
                                              attrs: {
                                                id: "Start Date",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                                name: "Start Date",
                                              },
                                              model: {
                                                value: _vm.DeliveryDate,
                                                callback: function ($$v) {
                                                  _vm.DeliveryDate = $$v
                                                },
                                                expression: "DeliveryDate",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "ripple",
                                      rawName: "v-ripple.400",
                                      value: "rgba(255, 255, 255, 0.15)",
                                      expression: "'rgba(255, 255, 255, 0.15)'",
                                      modifiers: { 400: true },
                                    },
                                  ],
                                  staticClass: "mr-1",
                                  attrs: { type: "submit", variant: "primary" },
                                  on: { click: _vm.AddPushOrder },
                                },
                                [
                                  _vm.pushLoading
                                    ? _c("b-spinner", { attrs: { small: "" } })
                                    : _vm._e(),
                                  _vm._v(" Submit "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-edit-push",
            centered: "",
            title: "Edit Push Order",
            "hide-footer": "",
          },
        },
        [
          _c(
            "b-container",
            [
              _c(
                "validation-observer",
                { ref: "addPushForm" },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Product" } },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.optionsProduct,
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.pushId.itemId,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.pushId, "itemId", $$v)
                                      },
                                      expression: "pushId.itemId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Order Number" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "orderNumber",
                                      name: "orderNumber",
                                      type: "text",
                                      placeholder: "orderNumber",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.pushId.orderNumber,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.pushId, "orderNumber", $$v)
                                      },
                                      expression: "pushId.orderNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Quantity" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "Quantity",
                                      name: "Quantity",
                                      type: "text",
                                      placeholder: "Quantity",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.pushId.quantity,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.pushId, "quantity", $$v)
                                      },
                                      expression: "pushId.quantity",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Comment",
                                    "label-for": "login-Comment",
                                  },
                                },
                                [
                                  _c("b-form-textarea", {
                                    attrs: {
                                      id: "login-Comment",
                                      name: "login-Comment",
                                      required: "",
                                      placeholder:
                                        "Description for Push Order | Add Customer details if for customer",
                                    },
                                    model: {
                                      value: _vm.pushId.comment,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.pushId, "comment", $$v)
                                      },
                                      expression: "pushId.comment",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Start Date",
                                    "label-for": "Start Date",
                                  },
                                },
                                [
                                  _c("b-form-datepicker", {
                                    attrs: {
                                      id: "Start Date",
                                      name: "Start Date",
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.pushId.deliveryDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.pushId,
                                          "deliveryDate",
                                          $$v
                                        )
                                      },
                                      expression: "pushId.deliveryDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "ripple",
                                      rawName: "v-ripple.400",
                                      value: "rgba(255, 255, 255, 0.15)",
                                      expression: "'rgba(255, 255, 255, 0.15)'",
                                      modifiers: { 400: true },
                                    },
                                  ],
                                  staticClass: "mr-1",
                                  attrs: { type: "submit", variant: "primary" },
                                  on: { click: _vm.updatePushOrders },
                                },
                                [
                                  _vm.pushLoading
                                    ? _c("b-spinner", { attrs: { small: "" } })
                                    : _vm._e(),
                                  _vm._v(" Submit "),
                                ],
                                1
                              ),
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "ripple",
                                      rawName: "v-ripple.400",
                                      value: "rgba(255, 255, 255, 0.15)",
                                      expression: "'rgba(255, 255, 255, 0.15)'",
                                      modifiers: { 400: true },
                                    },
                                  ],
                                  staticClass: "mr-1",
                                  attrs: { type: "submit", variant: "danger" },
                                  on: { click: _vm.deletePush },
                                },
                                [_vm._v(" Delete ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        { staticClass: "my-2", attrs: { title: "Orders" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "mb-0" },
                    [
                      _c(
                        "label",
                        { staticClass: "d-inline-block text-sm-left mr-50" },
                        [_vm._v("Per page")]
                      ),
                      _c("b-form-select", {
                        staticClass: "w-50",
                        attrs: {
                          id: "perPageSelect",
                          size: "sm",
                          options: _vm.pageOptions,
                        },
                        model: {
                          value: _vm.perPage,
                          callback: function ($$v) {
                            _vm.perPage = $$v
                          },
                          expression: "perPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "my-1", attrs: { md: "4", sm: "8" } },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        label: "Sort",
                        "label-cols-sm": "3",
                        "label-align-sm": "right",
                        "label-size": "sm",
                        "label-for": "sortBySelect",
                      },
                    },
                    [
                      _c(
                        "b-input-group",
                        { attrs: { size: "sm" } },
                        [
                          _c("b-form-select", {
                            staticClass: "w-75",
                            attrs: {
                              id: "sortBySelect",
                              options: _vm.sortOptions,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "first",
                                fn: function () {
                                  return [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v("-- none --"),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.sortBy,
                              callback: function ($$v) {
                                _vm.sortBy = $$v
                              },
                              expression: "sortBy",
                            },
                          }),
                          _c(
                            "b-form-select",
                            {
                              staticClass: "w-25",
                              attrs: { size: "sm", disabled: !_vm.sortBy },
                              model: {
                                value: _vm.sortDesc,
                                callback: function ($$v) {
                                  _vm.sortDesc = $$v
                                },
                                expression: "sortDesc",
                              },
                            },
                            [
                              _c("option", { domProps: { value: false } }, [
                                _vm._v("Asc"),
                              ]),
                              _c("option", { domProps: { value: true } }, [
                                _vm._v("Desc"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "my-1", attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        label: "Filter",
                        "label-cols-sm": "3",
                        "label-align-sm": "right",
                        "label-size": "sm",
                        "label-for": "filterInput",
                      },
                    },
                    [
                      _c(
                        "b-input-group",
                        { attrs: { size: "sm" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "filterInput",
                              type: "search",
                              placeholder: "Type to Search",
                            },
                            model: {
                              value: _vm.filter,
                              callback: function ($$v) {
                                _vm.filter = $$v
                              },
                              expression: "filter",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      responsive: "",
                      "per-page": _vm.perPage,
                      "current-page": _vm.currentPageDemand,
                      items: _vm.demandList,
                      fields: _vm.fields,
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc,
                      "sort-direction": _vm.sortDirection,
                      filter: _vm.filter,
                      "filter-included-fields": _vm.filterOn,
                    },
                    on: {
                      "update:sortBy": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sortDesc": function ($event) {
                        _vm.sortDesc = $event
                      },
                      "update:sort-desc": function ($event) {
                        _vm.sortDesc = $event
                      },
                      filtered: _vm.onFilteredDemand,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(orderId)",
                        fn: function (data) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  data.item.salesOrderId !== null
                                    ? data.item.salesOrderNumber
                                    : data.item.pushOrderNumber
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(orderType)",
                        fn: function (data) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  data.item.salesOrderId !== null
                                    ? "Proforma"
                                    : "Push Order"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(deliveryDate)",
                        fn: function (data) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm
                                    .dayjs(data.value)
                                    .format("DD/MM/YYYY hh:mm:ss")
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(select)",
                        fn: function (data) {
                          return [
                            _c("b-form-checkbox", {
                              staticClass: "custom-control-primary",
                              attrs: { value: data.item },
                              on: {
                                change: function ($event) {
                                  return _vm.selectedOrderChanged()
                                },
                              },
                              model: {
                                value: _vm.selectedOrders,
                                callback: function ($$v) {
                                  _vm.selectedOrders = $$v
                                },
                                expression: "selectedOrders",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell(actions)",
                        fn: function (data) {
                          return [
                            data.item.pushOrderId
                              ? _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-modal",
                                        rawName: "v-b-modal.modal-edit-push",
                                        modifiers: { "modal-edit-push": true },
                                      },
                                    ],
                                    attrs: { variant: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getPushData(
                                          data.item.pushOrderId
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" View ")]
                                )
                              : _c("span", { staticClass: "text-center" }, [
                                  _vm._v(" - "),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-center mb-1" },
                    [
                      _vm.jobLoading ||
                      _vm.customerLoading ||
                      _vm.productLoading ||
                      _vm.pushLoading
                        ? _c("b-spinner", {
                            staticStyle: { width: "3rem", height: "3rem" },
                            attrs: {
                              variant: "success",
                              label: "Spinning",
                              block: "",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-pagination", {
                    staticClass: "my-0",
                    attrs: {
                      "total-rows": _vm.totalRowsDemand,
                      "per-page": _vm.perPage,
                      align: "center",
                      size: "sm",
                    },
                    model: {
                      value: _vm.currentPageDemand,
                      callback: function ($$v) {
                        _vm.currentPageDemand = $$v
                      },
                      expression: "currentPageDemand",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }